import { render, staticRenderFns } from "./SmartObjectEditorControl.vue?vue&type=template&id=0664d331&scoped=true"
import script from "./SmartObjectEditorControl.vue?vue&type=script&lang=js"
export * from "./SmartObjectEditorControl.vue?vue&type=script&lang=js"
import style0 from "./SmartObjectEditorControl.vue?vue&type=style&index=0&id=0664d331&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664d331",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0664d331')) {
      api.createRecord('0664d331', component.options)
    } else {
      api.reload('0664d331', component.options)
    }
    module.hot.accept("./SmartObjectEditorControl.vue?vue&type=template&id=0664d331&scoped=true", function () {
      api.rerender('0664d331', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/SmartObjectEditorControl.vue"
export default component.exports